import { api } from "./api-core";

export interface IUserOrder {
  code: number;
  status: string;
  total: number;
  data: {
    // id: number;
    // certificate_id: number;
    // certificate_name: string;
    // certificate_link: string;
    // bill_file_url: string;
    // oa_file_url: string;
    // oa_file_name: string;
    // user_id: number;
    // first_name: string;
    // last_name: string;
    // phone: string;
    // email: string;
    // status: number;
    // created_at: string;
    // updated_at: string;

    id: number;
    itemName: string;
    itemLink: string;
    itemBillFileUrl: string;
    itemEmail: string;
    itemStatus: number;
    itemCreatedAt: string;
    itemType: string;
  }[];
}

export const MyOrderApi = {
  getUserOrders: () => {
    return api
      .get(process.env.API_GET_ORDERS as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
};
